import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = 29;

var e = /*#__PURE__*/function () {
  function e(_e) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t;

    _classCallCheck(this, e);

    this.name = _e, this._counter = 0, this._items = new Array(s);
  }

  _createClass(e, [{
    key: "record",
    value: function record(t) {
      this._items[++this._counter % this._items.length] = t;
    }
  }, {
    key: "median",
    get: function get() {
      return this._items.slice().sort(function (t, _e2) {
        return t - _e2;
      })[Math.floor(this._items.length / 2)];
    }
  }, {
    key: "average",
    get: function get() {
      return this._items.reduce(function (t, _e3) {
        return t + _e3;
      }, 0) / this._items.length;
    }
  }, {
    key: "last",
    get: function get() {
      return this._items[this._counter % this._items.length];
    }
  }]);

  return e;
}();

export { e as default };